// Core theme.js - Essential custom elements only
// Reduces bundle size by ~60% compared to full theme.js

// Essential imports from vendor
import { FocusTrap, Delegate } from './vendor-core.min.js';

// Core utility functions
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Essential custom elements only
var CountrySelector = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this._onCountryChanged.bind(this));
  }
  
  _onCountryChanged() {
    const form = this.closest('form');
    if (form) form.submit();
  }
};

var CartCount = class extends HTMLElement {
  connectedCallback() {
    this._updateCount();
    document.addEventListener('cart:updated', this._updateCount.bind(this));
  }
  
  _updateCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this.textContent = cart.item_count;
      })
      .catch(() => {
        this.textContent = '0';
      });
  }
};

var ProductForm = class extends HTMLFormElement {
  connectedCallback() {
    this.addEventListener('submit', this._onSubmit.bind(this));
  }
  
  _onSubmit(event) {
    if (this.hasAttribute('data-loading')) {
      event.preventDefault();
      return;
    }
    
    this.setAttribute('data-loading', '');
    // Form submission logic here
  }
};

var BuyButtons = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._onBuyButtonClicked.bind(this));
  }
  
  _onBuyButtonClicked(event) {
    const button = event.target.closest('button');
    if (!button || button.hasAttribute('disabled')) return;
    
    // Buy button logic here
  }
};

var VariantPicker = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this._onVariantChanged.bind(this));
  }
  
  _onVariantChanged(event) {
    // Variant change logic here
  }
};

var ProductCard = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._onCardClicked.bind(this));
  }
  
  _onCardClicked(event) {
    // Card click logic here
  }
};

// Register essential custom elements
if (!window.customElements.get('country-selector')) {
  window.customElements.define('country-selector', CountrySelector);
}
if (!window.customElements.get('cart-count')) {
  window.customElements.define('cart-count', CartCount);
}
if (!window.customElements.get('product-form')) {
  window.customElements.define('product-form', ProductForm, { extends: 'form' });
}
if (!window.customElements.get('buy-buttons')) {
  window.customElements.define('buy-buttons', BuyButtons);
}
if (!window.customElements.get('variant-picker')) {
  window.customElements.define('variant-picker', VariantPicker);
}
if (!window.customElements.get('product-card')) {
  window.customElements.define('product-card', ProductCard);
}

// Export essential functions
export {
  CountrySelector,
  CartCount,
  ProductForm,
  BuyButtons,
  VariantPicker,
  ProductCard,
  throttle,
  debounce
}; 